import { useField, usePage } from '@kizi/comparator-core';
import { Div } from '@kizi/core-components';
import { AccordionItem } from '@kizi/shared-components';
import React from 'react';
import {
  Filter,
  FiltersButton,
  FiltersButtonProps,
  ModalWithAccordion,
  Sorting,
  SortingProps,
} from '.';
import { isMobile } from '../utils/global';

export interface FiltersSortingProps {
  filters: FiltersButtonProps;
  sorting: SortingProps;
  showIcon?: boolean;
  hideResetFiltersOption?: boolean;
  showFaqModal?: boolean;
  items?: AccordionItem[];
}

export const FiltersSorting: React.FC<FiltersSortingProps> = ({
  filters,
  sorting,
  showIcon = false,
  hideResetFiltersOption = false,
  showFaqModal = false,
  items = [],
  ...restProps
}: FiltersSortingProps) => {
  return (
    <Div display="flex" justifyContent="space-between" {...restProps}>
      {!isMobile() && showFaqModal && (
        <ModalWithAccordion
          showIcon={true}
          buttonLabel="Veelgestelde vragen"
          buttonIcon="comment"
          buttonIconProps={{ name: 'comment', size: 18 }}
          title="Veelgestelde vragen"
          items={items}
        />
      )}
      <FiltersButton
        showIcon={showIcon}
        hideResetFiltersOption={hideResetFiltersOption}
        {...filters}
      />
      <Sorting {...sorting} />
    </Div>
  );
};

export interface FiltersSortingWrapperProps {
  title: string;
  filtersNameField: string;
  showIcon?: boolean;
  filtersTitle?: string;
  hideSorting?: boolean;
}

export const FiltersSortingWrapper: React.FC<FiltersSortingWrapperProps> = ({
  title,
  filtersNameField,
  showIcon = false,
  filtersTitle = 'Filteren',
  hideSorting = false,
  ...props
}) => {
  const { state } = usePage();
  const field = useField(filtersNameField);
  if (!field) return null;

  const choices = JSON.parse(field?.value as string);

  return (
    <FiltersSorting
      {...props}
      filters={{
        onChange: state?.onChange as any,
        choices: choices,
        data: (state?.availableFilters as Filter[]) ?? [],
        title: filtersTitle,
      }}
      showIcon={showIcon}
      sorting={{
        onItemClick: state?.onItemClick as Function,
        options:
          (state?.options as {
            icon: string;
            label: string;
            value: number;
          }[]) ?? [],
        selected: state?.selected as number,
        title,
        display: hideSorting ? 'none' : null,
      }}
    />
  );
};
